var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.072 3.05416L19.294 8.72016L14 10.9882L0.854 5.35416C1.15 5.05216 1.512 4.80816 1.924 4.65016L6.072 3.05416ZM8.748 2.02616L11.848 0.83416C13.2339 0.301374 14.7681 0.301374 16.154 0.83416L26.078 4.65016C26.488 4.81016 26.85 5.05016 27.146 5.35416L21.834 7.63016L8.748 2.02616ZM27.988 7.17016L15 12.7362V27.6362C15.3943 27.5697 15.7809 27.4638 16.154 27.3202L26.078 23.5022C26.6438 23.2843 27.1303 22.9002 27.4734 22.4003C27.8165 21.9005 28.0001 21.3084 28 20.7022V7.45016C28.0004 7.35664 27.9957 7.26317 27.986 7.17016H27.988ZM13 27.6362V12.7362L0.0139999 7.17016C0.00498694 7.26323 0.000315266 7.35666 0 7.45016V20.7022C8.0285e-05 21.3087 0.183985 21.9009 0.527462 22.4008C0.870939 22.9006 1.35786 23.2846 1.924 23.5022L11.846 27.3202C12.222 27.4642 12.608 27.5702 13 27.6362Z",
    fill: "#EB5757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.7454aec7e4a5f2c8c427852a6b992406.svg";
export { ForwardRef as ReactComponent };